/*
 * Copyright (c) 2023-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TextTruncate from "../TextTruncate.jsx";

class OutputListItem extends Component {
    constructor() {
        super();
        this.state = {
            isOpen: false
        }
    }


    toggleExtension() {
        this.setState((state) => ({
            isOpen: !state.isOpen
        }))

    }

    render() {
        let {titel, children, extended} = this.props
        let hasExtension = extended !== undefined

        return (
            <div className="grid grid-cols-3 gap-4 py-4 px-4">
                <dt className="text-sm font-medium text-gray-500 truncate"><TextTruncate>{titel}</TextTruncate></dt>
                <dd className=" text-sm text-gray-900 col-span-2 mt-0 truncate flex">
                    <TextTruncate>{children}</TextTruncate>
                    {hasExtension && (<>
                                        <span className={"italic hover:underline cursor-pointer text-xs text-gray-500"}
                                              onClick={() => this.toggleExtension()}>{this.state.isOpen ? ("less") : ("more")}</span>
                    </>)}

                </dd>
                {(hasExtension && this.state.isOpen) && (<div className={"col-span-3"}>
                    {extended}
                </div>)}
            </div>
        );
    }
}

OutputListItem.propTypes = {
    titel: PropTypes.string,
    children: PropTypes.any
};

export default OutputListItem;